module.exports = __webpack_public_path__ + "img/multi_robot_collaboration.e6df326b.png";